export const MAKE_REQUEST = "ACTION_MAKE_REQUEST";
export const FAIL_REQUEST = "ACTION_FAIL_REQUEST";
export const GET_ACTION_LIST = "GET_ACTION_LIST";
export const SET_REQUEST_FOR_REASSIGN = "SET_REQUEST_FOR_REASSIGN";
export const UPDATE_FETCH_ACTION_LIST_STATUS =
  "UPDATE_FETCH_ACTION_LIST_STATUS";
export const SET_SINGLE_ACTION_DETAILS = "SET_SINGLE_ACTION_DETAILS";
export const SET_UPDATE_IS_COMPLETE_RESPONSE =
  "SET_UPDATE_IS_COMPLETE_RESPONSE";
export const SET_ACTION_ACTIVITIES_DETAILS = "SET_ACTION_ACTIVITIES_DETAILS";
export const UPDATE_ISSUCCESS = "ACTION_UPDATE_ISSUCCESS";
export const SET_CANCEL_ACTION_RESPONSE = "SET_CANCEL_ACTION_RESPONSE";
export const SET_ACTION_LIST_FOR_CHART = "SET_ACTION_LIST_FOR_CHART";
export const SET_USER_TOTAL_DUE_ACTION_PRIORITY_WISE =
  "SET_USER_TOTAL_DUE_ACTION_PRIORITY_WISE";
export const MAKE_UPDATE_REQUEST = "MAKE_UPDATE_REQUEST";
export const SET_SUCCESS = "SET_SUCCESS";
export const SET_ACTION_DATA="SET_ACTION_DATA";
export const SET_ATTENDEE_CHART="SET_ATTENDEE_CHART"
export const SET_MEETING_CHART="SET_MEETING_CHART"
export const SET_MEETING_CHART_AND_ATTENDEE_CHART="SET_MEETING_CHART_AND_ATTENDEE_CHART"
export const CARD_CLICK_TYPE ="SET_CARD_CLICK_TYPE"
export const SET_HIDE_MY_TASK_BUTTON ="SET_HIDE_MY_TASK_BUTTON"
export const CHART_CLICK_TYPE ="CHART_CLICK_TYPE"
export const RE_ASSIGN_TYPE ="RE_ASSIGN_TYPE"
export const SET_ISCHECKED_REQUIRED="SET_ISCHECKED_REQUIRED";
export const FILTER_CLICK="FILTER_CLICK"